"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDepsVersion = exports.useVersion = exports.createDeeplyOptimizedCustomizedPropsHook = exports.createMemoizedFnCall = exports.useGetValueRef = exports.useUntypedProperty = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = require("react");
const prop_1 = require("./prop");
const deep_copy_1 = require("./deep-copy");
const objects_1 = require("./objects");
const _1 = require(".");
exports.useUntypedProperty = (obj, ...keys) => {
    return react_1.useMemo(() => {
        return prop_1.untypedGetProp(obj, ...keys);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [obj, JSON.stringify(keys)]);
};
exports.useGetValueRef = (val) => {
    const valRef = react_1.useRef(val);
    valRef.current = val;
    const getValRef = react_1.useRef(() => valRef.current);
    return getValRef;
};
exports.createMemoizedFnCall = (finalTransformationFn, memoizationStategy, getDependency) => {
    const finalTransormationMemoized = new WeakMap();
    return (rawValue) => {
        const dep = getDependency ? getDependency(rawValue) : rawValue;
        const prevFinalDataRef = react_1.useRef(null);
        if (memoizationStategy === "inside-component") {
            const finalValue = react_1.useMemo(() => finalTransformationFn(rawValue, prevFinalDataRef.current), [dep]);
            prevFinalDataRef.current = finalValue;
            return finalValue;
        }
        if (objects_1.isValidWeakMapKey(dep) && finalTransormationMemoized.has(dep)) {
            const finalValue = finalTransormationMemoized.get(dep);
            prevFinalDataRef.current = finalValue;
            return finalValue;
        }
        const finalValue = finalTransformationFn(rawValue, prevFinalDataRef.current);
        finalTransormationMemoized.set(dep, finalValue);
        prevFinalDataRef.current = finalValue;
        return finalValue;
    };
};
exports.createDeeplyOptimizedCustomizedPropsHook = (finalTransformationFn, memoizationStategy, getDependency) => {
    return exports.createMemoizedFnCall((rawData, previousFinalData) => {
        const computed = finalTransformationFn(rawData);
        if (!previousFinalData)
            return computed;
        return deep_copy_1.getDeeplyOptimizedValue(previousFinalData, computed, (oldValue, newValue) => {
            const areCusto = _1.isCustoClass(oldValue) || _1.isCustoClass(newValue);
            if (!areCusto)
                return { skip: true };
            return { skip: false, leaveOld: false };
        });
    }, memoizationStategy, getDependency);
};
exports.useVersion = (value, avoidVersionIncrement) => {
    const keyRef = react_1.useRef(1);
    const valueRef = react_1.useRef(value);
    if (valueRef.current !== value && !avoidVersionIncrement) {
        keyRef.current++;
    }
    valueRef.current = value;
    return keyRef.current;
};
exports.useDepsVersion = (deps) => {
    const keyRef = react_1.useRef(1);
    const depsRef = react_1.useRef(deps);
    if (depsRef.current !== deps &&
        depsAreShalowlyEqual(depsRef.current, deps)) {
        keyRef.current++;
    }
    depsRef.current = deps;
    return keyRef.current;
};
const depsAreShalowlyEqual = (prev, next) => {
    if (prev.length !== next.length)
        return false;
    for (let i = 0; i < prev.length; i++) {
        if (prev[i] !== next[i]) {
            return false;
        }
    }
    return true;
};
